class NgSetFocusDirective {
    static $inject = ['$timeout'];
    constructor($timeout) {
        this.restrict = 'A';
        this.$timeout = $timeout;
    }

    static factory($timeout) {
        'ngInject';
        return new NgSetFocusDirective($timeout);
    }
    compile() {
        return this.link.bind(this);
    }

    link(scope, element, attrs) {
        scope.$watch(attrs.ngSetFocus, (value) => {
            if (value !== null && value !== undefined && value) {
                this.$timeout(() => element[0].focus());
            }
        });
    }
}

// Explicit DI annotation for factory used in angular.directive registration
NgSetFocusDirective.factory.$inject = ['$timeout'];
export default NgSetFocusDirective.factory;
